'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Context = React__default["default"].createContext({
  filters: {},
  query: {}
});
function Provider(props) {
  var children = props.children;

  var _React$useState = React__default["default"].useState({}),
      filters = _React$useState[0],
      setFilters = _React$useState[1];

  var _React$useState2 = React__default["default"].useState({}),
      query = _React$useState2[0],
      setQuery = _React$useState2[1];

  var setContextFilters = React__default["default"].useCallback(function (context, filters) {
    return setFilters(function (prevFilters) {
      var _objectSpread2;

      return _objectSpread({}, prevFilters, (_objectSpread2 = {}, _objectSpread2[context] = filters, _objectSpread2));
    });
  }, []);
  var setContextQuery = React__default["default"].useCallback(function (context, query) {
    return setQuery(function (prevQuery) {
      var _objectSpread3;

      return _objectSpread({}, prevQuery, (_objectSpread3 = {}, _objectSpread3[context] = query, _objectSpread3));
    });
  }, []);
  var value = React__default["default"].useMemo(function () {
    return {
      filters: filters,
      query: query,
      setFilters: setContextFilters,
      setQuery: setContextQuery
    };
  }, [filters, query, setContextFilters, setContextQuery]);
  return /*#__PURE__*/React__default["default"].createElement(Context.Provider, {
    value: value
  }, children);
}

exports.Context = Context;
exports.Provider = Provider;
